import { NA } from '/@/shared/constants'
import { Type } from '../importers/interfaces'
import HexId from '../values/HexId'

export class DeviceType {
  public readonly name: string
  public readonly productCode: string
  public readonly revisionNo: string

  constructor(data: Type = { name: NA, productCode: NA, revisionNo: NA }) {
    this.name = data.name
    this.productCode = data.productCode !== NA ? String(HexId.make(data.productCode)) : NA
    this.revisionNo = data.revisionNo !== NA ? String(HexId.make(data.revisionNo)) : NA
  }
}
